import { render } from "./ConfirmationModal.vue?vue&type=template&id=649f9a65"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__